
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";

const CanvaToIndesign = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/CanvaToIndesign"
        ogImage="/images/canva2indesign-og-image.png"
      />

      <MagicianSection
        title={t("page/CanvaToIndesign:title")}
        subtitle={t("page/CanvaToIndesign:subtitle")}
        // TODO: the glow is not working in Chrome
        magicianLogoFile="canva"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/CanvaToIndesign:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/canva-to-indesign-example.png",
          alt: "Canva to InDesign converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.signUp"),
        }}
        elements={t(
          "page/CanvaToIndesign:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />
      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/CanvaToIndesign:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/canva-to-indesign-converted-file-elements.png",
          alt: t("page/CanvaToIndesign:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/CanvaToIndesign:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/CanvaToIndesign:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/CanvaToIndesign:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/CanvaToIndesign:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/CanvaToIndesign:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/CanvaToIndesign:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/CanvaToIndesign:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "CHECK-GREEN-ICON",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "CANVA",
            image: "/images/canva2ai-canva-preview.png",
            title: "Canva Demo Preview",
          },
          to: {
            iconType: "INDESIGN",
            image: "/images/canva2indesign-indesign-preview.png",
            title: "InDesign Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.canvaToIndesignPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}
export default CanvaToIndesign;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/canva-to-indesign',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  